import React from 'react';
import { ScanEanConnectorApollo, withMobileAppMode } from '@front-activerse/common-components';
import ScanBarCodeContainer from './ScanBarCodeContainer';
import { useLocation } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const ScanBarCodePage: React.FC<{ mobileAppMode: boolean }> = ({ mobileAppMode }) => {
  const location = useLocation();
  const aiAccess = sessionStorage.getItem('aiAccess');
  const dietAccess = sessionStorage.getItem('dietAccess');

  if (aiAccess === 'true' || dietAccess === 'true' || mobileAppMode) {
    return (
      <ScanEanConnectorApollo>
        {({
          scanBarcode,
          cancelScanBarcode,
        }: {
          scanBarcode: (ean: string) => Promise<unknown>;
          cancelScanBarcode: () => void;
        }) => (
          <ScanBarCodeContainer
            key={location.key}
            scanBarcode={scanBarcode}
            cancelScanBarcode={cancelScanBarcode}
          />
        )}
      </ScanEanConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default withMobileAppMode(ScanBarCodePage);
